import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import SignIn from "./pages/AuthPage";
import Home from "./pages/HomePage";
import Reading from "./pages/ReadingPage";
import PersonalArea from "./pages/PersonalAreaPage";
import TopBar from "./components/core/top-bar";
import BackgroundCircle from "../assets/SVGComponents/BackgroundCircle";
import ClassesManagement from "./pages/ClassesManagementPage";
import NotFoundPage from "./pages/NotFoundPage";
import SiddurReaderPage from "./pages/SiddurReaderPage";
import { isSiddurReaderEnabled } from "../utils/feature-switches";
import { preloadAllSounds } from "../utils/sound.utils";
import { useEffect } from "react";

// ייבוא דפי האדמין
import AdminPanelLayout from "./pages/admin/AdminPanelLayout";
import OverviewPage from "./pages/admin/OverviewPage";
import PrincipalDashboardPage from "./pages/admin/PrincipalDashboardPage";
import AdminDefaultRedirect from "./pages/admin/AdminDefaultRedirect";
import UsersManagementPage from "./pages/admin/UsersManagementPage";
import StatisticsPage from "./pages/admin/StatisticsPage";
import SchoolManagementPage from "./pages/admin/SchoolManagementPage";
import ReadingSessionsDashboardPage from "./pages/admin/ReadingSessionsDashboardPage";

// trigger deploy
function App() {
  useEffect(() => {
    preloadAllSounds();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route element={<LayoutWithHeader />}>
          <Route path="home" element={<Home />} />
          <Route path="reading" element={<Reading />} />
          <Route
            path="siddur"
            element={isSiddurReaderEnabled() ? <SiddurReaderPage /> : <Navigate to="/home" replace />}
          />
          <Route path="personal-area" element={<PersonalArea />} />
          <Route path="student-area" element={<PersonalArea />} />
          <Route path="classes-management" element={<ClassesManagement />} />
        </Route>
        {/* נתיבי האדמין - כולל מנהלי בתי ספר */}
        <Route path="/admin-panel" element={<AdminPanelLayout />}>
          <Route index element={<AdminDefaultRedirect />} />
          <Route path="overview" element={<OverviewPage />} />
          <Route path="principal-dashboard" element={<PrincipalDashboardPage />} />
          <Route path="statistics" element={<StatisticsPage />} />
          <Route path="reading-sessions" element={<ReadingSessionsDashboardPage />} />
          <Route path="users-management" element={<UsersManagementPage />} />
          <Route path="schools-management" element={<SchoolManagementPage />} />
        </Route>
        {/* נתיב 404 - חייב להיות אחרון */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

function LayoutWithHeader() {
  return (
    <div className="app-container">
      <BackgroundCircle />
      <TopBar />
      <Outlet />
    </div>
  );
}

export default App;
